import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line

import NavBar from '../../components/toolbars/NavBar';
import { UserActions } from '../../actions/user';
import '../../styles/Dashboard.css';

class ConfirmEmail extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    hash: PropTypes.string.isRequired
  }

  confirm = () => {
    const { dispatch, hash } = this.props;
    dispatch(UserActions.confirmEmail(hash));
  }

  render() {
    return (
      <div className="main-container">
        <NavBar />
        <div className="row">
          <div className="col-md-12">
            <h2>Email Confirmation</h2>
            <button
              className="btn btn-primary"
              onClick={this.confirm}
            >Confirm Email Address</button>
          </div>
        </div>
      </div>
    );
  }
}

@connect(_state => ({
}))
export default class ConfirmEmailContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object
  }

  render() {
    const { dispatch, params: { hash } } = this.props;
    return (
      <ConfirmEmail dispatch={dispatch} hash={hash} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/public/ConfirmEmail.js